const SettingsVideo = () => <>hello world!</>;

export default SettingsVideo;
